import { EnvironmentUrls } from 'Roblox';
import proxy from '../../libs/proxy';
import { CacheCriteria } from '../../libs/constants';
const { presenceApi } = EnvironmentUrls;

type DataStoreCallback = (data: object) => void;

class PresenceProvider {
  public static getUserPresence(userIds: Array<number>, callback: DataStoreCallback, cacheCriteria?: CacheCriteria) {
    const urlConfig = {
      url: `${presenceApi}/v1/presence/users`,
      method: proxy.RequestType.Post,
      retryable: true,
      withCredentials: true,
      data: {
        userIds
      }
    };
    const batchCriteria = {
      key: 'userIds',
      limit: 100,
      isBatchEnabled: true
    };
    return proxy.subscribe(callback, urlConfig, cacheCriteria, batchCriteria);
  }

  public static refreshUserPresence(userIds: Array<number>, cacheCritiera?: CacheCriteria) {
    const urlConfig = {
      url: `${presenceApi}/v1/presence/users`,
      method: proxy.RequestType.Post,
      retryable: true,
      withCredentials: true,
      data: {
        userIds
      }
    };
    const batchCriteria = {
      key: 'userIds',
      limit: 100,
      isBatchEnabled: true
    };
    return proxy.refresh(urlConfig, cacheCritiera, batchCriteria);
  }
}

export default PresenceProvider;
